import { createReducer } from 'typesafe-actions';

import { ISetSidebarAction, ISidebarState, sidebarActionTypes } from '@/router/store/sidebar.types';

export const initialState: ISidebarState = {
  isOpen: true,
};

export const sidebarReducer = createReducer<ISidebarState, ISetSidebarAction>(initialState).handleType(
  sidebarActionTypes.SET_SIDEBAR,
  (state, action) => {
    return {
      ...state,
      isOpen: action.isOpen,
    };
  },
);
